import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as TrophySvg } from './assets/trophy-filled.svg';

const ThropyFilledIcon = React.forwardRef((args, ref) => <SvgIcon component={TrophySvg} ref={ref} {...args} />);

export default ThropyFilledIcon;
